<template>
  <!-- Main content -->
  <section class="content">
    <!-- Info boxes -->
    <div class="row">
      <v-app>
        <v-content>
          <v-container fluid>
            <v-alert
              value="message" v-if="message"
              type="success"
              outline
            > <span> {{ message }} </span>
            </v-alert>

             <v-alert
              value="error" v-if="error"
              type="warning"
              outline
            > <span> {{ error }} </span>
            </v-alert>

           <v-dialog v-model="dialog" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="headline">Edit Merchant</span>
              </v-card-title>

              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                   <v-form ref="form" v-model="valid" lazy-validation>
                      <v-text-field
                       v-model="editedItem.id"
                       label="Id"
                       required
                       readonly
                       >
                       </v-text-field>

                      <v-text-field
                       v-model="editedItem.name"
                       label="Originator Name"
                       :rules="nameRules"
                       required
                       >
                       </v-text-field>

                      <v-text-field
                       v-model="editedItem.merchantId"
                       label="Merchant Id"
                       :rules="merchantIdRules"
                       required
                       >
                       </v-text-field> 
                       <v-select
                        :items="templates"
                        label="Template"
                        v-model="templateId"
                        solo
                        item-text="name"
                        item-value="id"
                        :rules="templateRules"
                        required
                        autocomplete
                      >
                      </v-select> 
                      <v-text-field
                       name="settlement_account"
                       v-model="editedItem.settlement_account"
                       label="Settlement Account" 
                       >
                       </v-text-field>
                      <v-text-field
                      class="d-none"
                       name="suspense_account1"
                       v-model="editedItem.suspense_account1"
                       label="Suspense Account 1" 
                       >
                       </v-text-field>
                       <v-text-field
                       class="d-none"
                       name="suspense_account2"
                       v-model="editedItem.suspense_account2"
                       label="Suspense Account 2" 
                       >
                       </v-text-field>
                       <v-text-field
                       name="Comment"
                       v-model="editedItem.makerComment"
                       label="Maker Comment"
                       :rules="makerCommentRules"
                       required
                       >
                       </v-text-field>

                    </v-form>
                  </v-layout>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" @click.native="close">Cancel</v-btn>
                <v-btn color="accent" @click.native="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
            <v-layout row pr-1 mr-1 pb-1 mb-1>
              <v-spacer></v-spacer>
              <v-flex xs3>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-flex>
            <!-- <v-spacer></v-spacer>
            <v-flex xs3>
              <v-menu
    v-model="menu.startDate"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="startDate"
        label="Start Date"
        readonly
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="startDate"
      ref="startDatePicker"
      scrollable
      @input="closeDatePicker('startDate')"
    ></v-date-picker>
  </v-menu>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs3>
              <v-menu
    v-model="menu.endDate"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="endDate"
        label="End Date"
        readonly
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="endDate"
      ref="endDatePicker"
      scrollable
      @input="closeDatePicker('endDate')"
      :max="maxDate"
    ></v-date-picker>
  </v-menu>

            </v-flex>       -->
  <!-- ... (other template code) -->




  <!-- ... (other template code) -->


      <!-- <v-menu
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="startDate"
            label="Start Date"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="startDate"
          ref="endDatePicker"
          scrollable
          @input="closeDatePicker('endDate')"
        ></v-date-picker>
      </v-menu>
    </v-flex>
<v-menu
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="endDate"
          label="End Date"
          readonly
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="endDate"
        ref="endDatePicker"
        scrollable
        @input="closeDatePicker('endDate')"
      ></v-date-picker>
    </v-menu> -->
           </v-layout>
            <v-data-table
              :headers="headers"
              :items="merchants"
              :pagination.sync="pagination"
              :total-items="totalMerchants"
              :loading="loading"
              class="elevation-1"
              :search="search"
            >
             <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="body-2 font-weight-regular accent--text"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.id }}</td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.merchantId }}</td>
              <td>{{ props.item.parent == null ? 'isParent' : props.item.parent }}</td>
              <td>{{ props.item.template.name }}</td>
              <td>{{ props.item.settlement_account }}</td>
              <!-- <td>{{ props.item.suspense_account1 }}</td>
              <td>{{ props.item.suspense_account2 }}</td> -->
              <td>{{ props.item.createdAt }}</td>
              <td>
                <router-link class="pageLink" v-bind:to="'/merchant/'+ props.item.id +'/configure'">
                  <v-btn class="secondary" small>
                   Configure
                  </v-btn>
                </router-link>
              </td>
              <td class="justify-center layout px-0">
                <v-icon
                  small left
                  class="mr-2"
                  @click="editItem(props.item)"
                >
                  edit
                </v-icon>
              </td>
              <td class="justify-center layout px-0">
                <v-icon
                  small left
                  class="mr-2"
                  @click="showDeleteDialog(props.item)"
                >
                  delete
                </v-icon>
              </td>
            </template>
            <template slot="no-data">
              <p> No data Found </p>
              <v-btn color="primary" @click="getDataFromApi">Reload</v-btn>
            </template>
           </v-data-table>

          <v-dialog v-model="deleteDialog" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="headline">Delete Merchant</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <p> Are you sure you want to delete {{ deleteItem.name }} ? </p>
                  </v-layout>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" @click.native="closeDeleteDialog">Cancel</v-btn>
                <v-btn color="accent" @click.native="saveDelete">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          </v-container>
        </v-content>
      </v-app>
    </div>
    <!-- /.row -->
  </section>
  <!-- /.content -->
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'

export default {
  name: 'viewmerchants',
  data: function() {
    return {
      startDate: new Date().toISOString().substr(0, 10),
      endDate: new Date().toISOString().substr(0, 10),
      maxDate: new Date().toISOString().substr(0, 10),
      menu: {},
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Name', value: 'name' },
        { text: 'Merchant Id', value: 'merchantId' },
        { text: 'Parent', value: 'merchantId' },
        { text: 'Template', value: 'template' },
        // { text: 'Settlement Account', value: 'settlement_account' },
        // { text: 'Suspense Account 1', value: 'suspense_account1' },
        // { text: 'Suspense Account 2', value: 'suspense_account2' },
        { text: 'Created At', value: 'createdAt' }
      ],
      merchants: [],
      message: '',
      error: '',
      loading: true,
      pagination: {},
      totalMerchants: 0,
      dialog: false,
      editedIndex: -1,
      defaultItem: {
        id: '',
        name: '',
        merchantId: '',
        makerComment: '',
        settlement_account: '',
        suspense_account1: '',
        suspense_account2: ''
      },
      editedItem: {
        'id': '',
        'name': '',
        'merchantId': '',
        'makerComment': ' ',
        'settlement_account': ' ',
        'suspense_account1': ' ',
        'suspense_account2': ' '
      },
      valid: true,
      nameRules: [
        v => !!v || 'Merchant Name is required'
      ],
      merchantIdRules: [
        v => !!v || 'Merchant Id is required'
      ],
      makerCommentRules: [
        v => !!v || 'Comment is required'
      ],
      templateRules: [
        v => !!v || 'Template is required'
      ],
      // suspense_account1Rules: [
      //   v => !!v || 'Suspense Account 1 is required'
      // ],
      // suspense_account2Rules: [
      //   v => !!v || 'Suspense Account 2 is required'
      // ],
      search: '',
      templates: [],
      templateId: null,
      deleteItem: {},
      deleteDialog: false
    }
  },
  watch: {
    pagination: {
      handler () {
        this.getDataFromApi()
          .then(data => {
            // this.users = data.items
            // this.totalUsers = data.total
          })
      },
      deep: true
    },
    startDate: {
      handler: function(newStartDate, oldStartDate) {
        // Call the "getMerchants" method whenever "startDate" changes
        this.getMerchants()
      },
      deep: true // Watch for deep changes in startDate if needed
    },
    endDate: {
      handler: function(newEndDate, oldEndDate) {
        // Call the method that needs to use the end date here
        this.getMerchants()
      },
      deep: true // Watch for deep changes in endDate if needed
    }
  },
  mounted () {
    this.getDataFromApi()
      .then(data => {
        // this.users = data.items
        // this.totalUsers = data.total
      })
    this.getTemplates()
  },
  methods: {
    getDataFromApi () {
      this.loading = true
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        console.log('this.pagination ====== ===>' + JSON.stringify(this.pagination))
        let items = this.getMerchants(page, rowsPerPage)
        const total = items.length

        if (this.pagination.sortBy) {
          items = items.sort((a, b) => {
            const sortA = a[sortBy]
            const sortB = b[sortBy]

            if (descending) {
              if (sortA < sortB) return 1
              if (sortA > sortB) return -1
              return 0
            } else {
              if (sortA < sortB) return -1
              if (sortA > sortB) return 1
              return 0
            }
          })
        }

        if (rowsPerPage > 0) {
          items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage)
        }

        setTimeout(() => {
          this.loading = false
          resolve({
            items,
            total
          })
        }, 1000)
      })
    },
    editItem (item) {
      this.editedIndex = this.merchants.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.templateId = this.editedItem.template.id
      this.dialog = true
    },
    showDeleteDialog (item) {
      this.deleteItem = item
      this.deleteDialog = true
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          console.log(this.editedItem)
          this.saveMerchant()
        }
        this.close()
      }
    },
    saveMerchant() {
      var url = config.serverURI + '/merchant/update'
      var token = store.state.token
      this.editedItem.templateId = this.templateId
      console.log(this.editedItem)
      axios.post(url, this.editedItem, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            console.log('Update Response:', response)
            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }

            if (response.data.error === true) {
              this.error = response.data.message
              return
            }

            this.message = response.data.message
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            var data = error.response.data
            console.log(data.message)
            if (data.message === 'Unauthorized') {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
    },
    getNextStartRecord(page, rowsPerPage) {
      return (page - 1) * rowsPerPage + 1
    },

    getMerchants (page, rowsPerPage) {
      let nextStartRecord = this.getNextStartRecord(page, rowsPerPage)
      console.log('page  rowsPerPage   nextStartRecord' + page + rowsPerPage + nextStartRecord)
      // var url = config.serverURI + '/merchant/getperpage?startRecordNo=' + nextStartRecord + '&nextFetchRecords=' + rowsPerPage
      var url = config.serverURI + '/merchant/get'
      var token = store.state.token
      // const { sortBy, descending, page, rowsPerPage } = this.pagination
      // const queryParams = {
      //   sortBy,
      //   descending,
      //   page,
      //   rowsPerPage,
      //   startDate: this.startDate // Include the start date
      // }
      axios.get(url, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            console.log('API Response:', response)

            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }
            this.merchants = response.data
            this.totalMerchants = this.merchants.total
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            var data = error.response
            console.log(data)
            if (data.status === 401) {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
      return this.merchants
    },
    getTemplates () {
      var url = config.serverURI + '/merchant/templates'
      var token = store.state.token
      axios.get(url, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }
            this.templates = response.data
          })
          .catch(error => {
            console.log('error', error.response)
            var data = error.response
            console.log(data)
            if (data.status === 401) {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
    },
    closeDeleteDialog () {
      this.deleteDialog = false
      this.deleteItem = {}
    },
    saveDelete () {
      var url = config.serverURI + '/merchant/delete'
      var token = store.state.token
      this.deleteItem.templateId = this.deleteItem.template.id
      console.log(this.deleteItem)
      axios.post(url, this.deleteItem, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            console.log('Delete Response:', response)
            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              this.closeDeleteDialog()
              return
            }

            if (response.data.error === true) {
              this.error = response.data.message
              this.closeDeleteDialog()
              return
            }

            this.message = response.data.message
            this.closeDeleteDialog()
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            var data = error.response.data
            console.log(data.message)
            if (data.message === 'Unauthorized') {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
              this.closeDeleteDialog()
            }
          })
    },
    closeDatePicker(pickerName) {
      // Use the pickerName parameter to determine which date picker to close
      this.menu[pickerName] = false
    }
  }
}

</script>
<style>
.info-box {
  cursor: pointer;
}

.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}

.fullCanvas {
  width: 100%;
}
.d-none {
  display: none;
}

</style>



// WEBPACK FOOTER //
// viewmerchants.vue?21b8e5c8